
export enum AlertCode {
  SUCCESS = 'success',
  ALERT = 'alert',
  INFO = 'info',
  ERROR = 'error',
  BLOCKING_ERROR = 'blocking_error'
}

export enum eUrlMode {
  NONE,
  ASPX,
  ANG
}

export class ConfigKey {
  public static IMGSIZE: string = 'MEDIAS_IMG_SIZE';
  public static VIDEOSIZE: string = 'MEDIAS_VIDEO_SIZE';
  public static DOCSIZE: string = 'MEDIAS_DOC_SIZE';
  public static AUDIOSIZE: string = 'MEDIAS_AUDIO_SIZE';
  public static IMGFOLDER: string = 'IMAGESFOLDER';
  public static IMGHTTP: string = 'IMAGESHTTP';
  public static ESTORE: string = 'ESTORE_SITE';
  public static ESTOREWS: string = 'ESTORE_WS';
  public static WEBSTORE: string = 'WEBSTORE_SITE';
  public static WEBSTOREWS: string = 'WEBSTORE_WS';
  public static STREAM_HTTP: string = 'QUEOVAL_STREAM';
  public static STREAM_URL = 'QUEOVAL_STREAM_URL';
  public static STREAM_FOLDER: string = 'QUEOVAL_STREAM_FOLDER';
  public static SCORM_API: string = 'SCORM_API';
  public static SCORM_SITE: string = 'SCORM_SITE';
  public static ELEARNING_SITE: string = 'ELEARNING_SITE';
  public static QUESTIONNAIRE_SITE: string = 'QUESTIONNAIRE_SITE';
}

export enum eBreadMode {
  ADDING,
  CHANGE,
  BACK,
  DELETE,
  RELOAD
}

export class CodeIdent {
  public static ID_Admin: string = "1389";
  public static ID_Entite: string = "1348";
  public static tDOFicheTemps: string = "TBL_tDOFicheTemps";
  public static tUSGroupe: string = "TBL_tUSGroupe";
  public static tDOPersonne: string = "TBL_tDOPersonne";
  public static tPAProduit: string = "TBL_tPAProduit";
  public static tDORelation: string = "TBL_tDORelation";
  public static tDOEvenement: string = "TBL_tDOEvenement";
  public static tUSBrick: string = "TBL_tUSBrick";
  public static tUSLanceur: string = "TBL_tUSLanceur";
  public static tBOListe: string = "TBL_tBOListe";
  public static tDOClient: string = "TBL_tDOClient";
  public static tDOProduction: string = "TBL_tDOProduction";
  public static tDoMillesime: string = "TBL_tDOMillesime";
  public static tDOPrestation: string = "TBL_tDOPrestation";
  public static tDODocument: string = "TBL_tDODocument";
  public static tDOHistorique: string = "TBL_tDOHistorique";
  public static tDOInfosFiscalAGACGA: string = "TBL_tDOInfoFiscale";
  public static tDODevis: string = "TBL_tDODevis";
  public static tDOBrouillard: string = "TBL_tDOBrouillard";
  public static tDODebours: string = "TBL_tDODebours";
  public static tDODepense: string = "TBL_tDODepense";
  public static tDONoteF: string = "TBL_tDONoteF";
  public static tBOProperty: string = "TBL_tBOProperty";
  public static DossierParametre: string = "DossierParametre";
  public static LAN_Accueil: string = "LAN_ACCUEIL";
  public static LAN_Portail: string = "LAN_PORTAIL";
  public static LAN_Profil: string = "LAN_PROFIL";
  public static LAN_Scenarii: string = "LAN_SCENARIO";
  public static BLO_EXPLOBJ: string = "BLO_EXPLOBJ";
  public static tDOObjet: string = "TBL_tDOObjet";
  public static BO_CONTACT: string = "BO_CONTACT";
  public static BO_FORMATEUR: string = "BO_FORMATEUR";
  public static BO_ADRESSE: string = "BO_ADRESSE";
  public static BO_Brick: string = "BO_BKC";
  public static BO_CVT: string = "BO_CVT";
  public static BO_BO: string = "BO_BO";
  public static BO_Conteneur: string = "BO_CONT";
  public static BO_PARAMAPP: string = "BO_PARAMAPP";
  public static BO_LICENCE: string = "BO_LICENCE";
  public static BO_LIVRAISON: string = "BO_LIVRAISON";
  public static BO_Lanceur: string = "BO_SHORTCUT";
  public static BO_Param: string = "BO_VALAUTO";
  public static BO_TELERADIO: string = "BO_TELERADIO";
  public static BO_Property: string = "BO_PROP";
  public static BO_LIGNE: string = "BO_LIGNE";
  public static BO_PORTAIL_LIGNE: string = "BO_PORTAIL_LIGNE";
  public static BO_User: string = "BO_CNX";
  public static BO_UserPortail: string = "BO_CNX_PRT";
  public static BO_UserPortailEL: string = "BO_CNX_PRTEL";
  public static BO_Relation: string = "BO_REL";
  public static BO_ASSTV: string = "BO_TRW";
  public static BO_Table: string = "BO_TBL";
  public static BO_Colonne: string = "BO_COL";
  public static BO_Entite: string = "BO_CENT";
  public static BO_Bureau: string = "BO_BUREAU";
  public static BO_Block: string = "BO_BLOCK";
  public static BO_Rdv: string = "BO_RV";
  public static BO_NOTFRAI: string = "BO_NOTFRAI";
  public static BO_DOCNF: string = "BO_DOCNF";
  public static BO_CONGE: string = "BO_CONGE";
  public static BO_Rdv_PERIODIQUE: string = "BO_RDVPERIODIQUE";
  public static BO_DossierDocument: string = "BO_DOSSIER_DOC";
  public static BO_Fournisseur: string = "BO_FOURNISSEUR";
  public static BO_Insee: string = "BO_CP";
  public static BO_LA: string = "BO_LA";
  public static BO_LDM: string = "BO_LDM";
  public static BO_LIGNEDEVIS: string = "BO_LIGNEDEVIS";
  public static BO_PRESTATION: string = "BO_PRESTATION";
  public static BO_CATALOGUE: string = "BO_CATALOGUE";
  public static BO_PRESTATION_RAPIDE: string = "BO_PRESTATION_RAPIDE";
  public static BO_DOSSIER_CPTA: string = "BO_DOSSIER_CPTA";
  public static BO_Tache: string = "BO_TASK";
  public static BO_PostIt: string = "BO_POSTIT";
  public static BO_SYNCHRO: string = "BO_SYNCHRO";
  public static BO_STAGE: string = "BO_STAGE";
  public static BO_RESERV: string = "BO_RESERV";
  public static BO_PERSONNEL: string = "BO_PERSONNEL";
  public static BO_FICHETEMPS: string = "BO_FTMPS";
  public static BO_RELANCE: string = "BO_RELANCE";
  public static BO_MISSION_CAC: string = "BO_MCAC";
  public static BO_MISSION_SOCIALE: string = "BO_MGESP";
  public static BO_MISSION_CONSEIL: string = "BO_MGEST";
  public static BO_MISSION_JURIDIQUE: string = "BO_MJUR";
  public static BO_MISSION_COMPTA: string = "BO_MCPTA";
  public static BO_MISSION_ASSISTANCE: string = "BO_MASSISTANCE";
  public static BO_MISSION_HEBERGEMENT: string = "BO_MHEBERGEMENT";
  public static BO_MISSION_DEV: string = "BO_DEV";
  public static BO_MISSION_MAINT: string = "BO_MAINT";
  public static BO_MISSION_CONTRAT: string = "BO_MCON";
  public static BO_MISSION_LOCATION: string = "BO_MLOC";
  public static BO_MFILTRE: string = "BO_MFILTRE";
  public static BO_MILLESIME: string = "BO_MILLESIME";
  public static BO_DEBOURS: string = "BO_DEBOURS";
  public static BO_TASK_MAN: string = "BO_TASK_MAN";
  public static BO_GROUPEFAC: string = "BO_GRPFACT";
  public static BO_HISTOCLI: string = "BO_HISTOCLI";
  public static BO_ENTITEFACT: string = "BO_CENTFACT";
  public static BO_TMP_COL: string = "BO_TMP_COL";
  public static BO_SEGMENTATION: string = "BO_SEGM";
  public static BO_MODELE: string = "BO_MODELE";
  public static BO_TMP_TYPCOL: string = "BO_TMP_TYPCOL";
  public static BO_Parametre: string = "BO_PAR";
  public static BO_Procedure: string = "BO_PROCEDURE";
  public static BO_ClientSociete: string = "BO_CSOC";
  public static BO_ClientSocieteCloture: string = "BO_CSOC_CLOT";
  public static BO_RibClient: string = "BO_RIB";
  public static BO_RibEntiteFact: string = "BO_RIB_COMPTA";
  public static BO_INFOSFIS: string = "BO_INFOFIS";
  public static BO_Prospect: string = "BO_CPPT";
  public static BO_Dirigeant: string = "BO_DIRIGEANT";
  public static BO_collaborateur: string = "BO_COLLABO";
  public static BO_Notification: string = "BO_NOTIUSER";
  public static BO_IdentUnique: string = "BO_IDENTU";
  public static BO_Email: string = "BO_EMAIL";
  public static BO_Fax: string = "BO_Fax";
  public static BO_Courrier: string = "BO_Courrier";
  public static BO_DocumentDivers: string = "BO_DOCUMENT";
  public static BO_TICKET_MAIL: string = "BO_TICKET_MAIL";
  public static BO_TICKET_APPEL: string = "BO_TICKET_APPEL";
  public static BO_TICKET_COURRIER: string = "BO_TICKET_COURRIER";
  public static BO_TICKET_FAX: string = "BO_TICKET_FAX";
  public static BO_TICKET_APPEL_SAISI: string = "BO_TICKET_APPEL_SAISI";
  public static BO_FACTURE_TEMP: string = "BO_FACTURE_TEMP";
  public static BO_FACTURE: string = "BO_FACTURE";
  public static BO_LIGNEFACTURE_FRAIS: string = "BO_LIGNEFACTURE_FRAIS";
  public static BO_LIGNEFACTURE: string = "BO_LIGNEFACTURE";
  public static BO_LIGNEFACTURE_REGUL: string = "BO_LIGNEFACTURE_REGUL";
  public static BO_GROUPE_LIGNEFACTURE: string = "BO_GROUPE_LIGNEFACTURE";
  public static BO_LIGNEAVOIR: string = "BO_LIGNEAVOIR";
  public static BO_AVOIR: string = "BO_AVOIR";
  public static BO_PLAN: string = "BO_PLAN";
  public static BO_DETAIL_PLAN: string = "BO_DETAIL_PF";
  public static BO_REGLEMENT: string = "BO_REGLEMENT";
  public static BO_MODEFACTURATION: string = "BO_MODEFACT";
  public static BO_DEVIS: string = "BO_DEVIS";
  public static BO_FAMILLE: string = "BO_FAMILLE";
  public static BO_CHAMBRE: string = "BO_CHAMBRE";
  public static BO_RESERV_FAM: string = "BO_RESERV_FAM";
  public static PORTAIL_Notification: string = "BO_NOTIPTAL";
  public static PORTAIL_ALERTE: string = "BO_ALERTEPTAL";
  public static PORTAIL_APPELTEL: string = "BO_APPELPTAL";
  public static PORTAIL_SUIVI: string = "BO_SUIVIPTAL";
  public static PORTAIL_DOC: string = "BO_SUIVIDOC";
  public static PORTAIL_RESERVATION: string = "BO_RESERVPTAL";
  public static BO_STOCK: string = "BO_STOCK";
  public static PORTAIL_TACHE: string = "BO_TACHEPTAL";
  public static PORTAIL_TACHE_EQUIPE: string = "BO_TACHEEQPPTAL";
  public static PORTAIL_RDV: string = "BO_RDVPTAL";
  public static PORTAIL_TACHE_GROUPE: string = "BO_TACHE_GROUP_PTAL";
  public static PORTAIL_TACHE_CATEG: string = "BO_TACHE_CATEG";
  public static PORTAIL_TACHE_PRIORITE: string = "BO_TACHE_PRIORITE";
  public static BO_PROFIL: string = "BO_PROFIL";
  public static BO_EXPERT: string = "BO_EXPERT";
  public static BO_ACCOMPTE: string = "BO_ACCOMPTE";
  public static BO_LIGNEACCOMPTE: string = "BO_LIGNEACCOMPTE";
  public static BO_ECHEANCIER: string = "BO_ECHEANCIER";
  public static BO_ACTIONCO: string = "BO_ACTIONCO";
  public static BO_FICHCORRESP: string = "BO_FICHCORRESP";
  public static BO_DOC_PORTAIL: string = "BO_DOC_PORTAIL";
  public static BO_CSOC_PORTAIL: string = "BO_CSOC_PORTAIL";
  public static BO_CONTACT_PORTAIL: string = "BO_CONTACT_PORTAIL";
  public static BO_CONTACT_PRTEL: string = "BO_CONTACT_PRTEL";
  public static BO_FICHE_TECHNIQUE: string = "BO_FICHE_TECH";
  public static BO_FICHE_TECHNIQUE_PRODUIT: string = "BO_PROD_FICHE_TECH";
  public static BO_GROUPE_VIRTUEL: string = "BO_GROUPE_V";
  public static BO_AFFAIRE: string = "BO_AFFA";
  public static BO_OBLIGATION: string = "BO_OBLIGATION";
  public static BO_OBLIGATION_MANU: string = "BO_OBLIGATION_MANU";
  public static BO_HISTOCONTROL: string = "BO_HISTOCONTROL";
  public static BO_IMMEUBLE: string = "BO_IMMEUBLE";
  public static BO_MODELE_MAIL: string = "BO_MODELE_MAIL";
  public static BO_PROJET: string = "BO_MFORADQ";
  public static BO_Ogdpc: string = "BO_OGDPC";
  public static BO_CNT: string = "BO_CNT";
  public static BO_LIENINFO: string = "BO_LIENINFO";
  public static BO_CYCLEEL: string = "BO_CYCLEEL";
  public static BO_CATALOGUEEL: string = "BO_CATALOGUEEL";
  public static BO_CHAPITRE: string = "BO_CHAPITRE";
  public static BO_CONNAISSANCE: string = "BO_CONNAISSANCE";
  public static BO_CONNAISSANCE_PRT: string = "BO_CONNAISSANCE_PRT";
  public static BO_FORMATEUR_PRT: string = "BO_FORMATEUR_PRT";
  public static BO_MODELQUESTIONNAIRE: string = "BO_MODELQUESTIONNAIRE";
  public static BO_MODELQUESTION: string = "BO_MODELQUESTION";
  public static BO_MODELREPONSE: string = "BO_MODELREPONSE";
  public static BO_MEDIA: string = "BO_MEDIA";
  public static BO_GROUPESTAT: string = "BO_GROUPESTAT";
  public static BO_LIGNESTAT: string = "BO_LIGNESTAT";
  public static BO_QUESTGROUPE: string = "BO_QUESTGROUPE";
  public static BO_QUESTQUESTION: string = "BO_QUESTQUESTION";
  public static BO_QUESTREPONSE: string = "BO_QUESTREPONSE";
  public static BO_SELEARNCHA: string = "BO_SELEARNCHA";
  public static BO_SELEARNHC: string = "BO_SELEARNHC";
  public static BO_SELEARNTC: string = "BO_SELEARNTC";
  public static BO_CNX_PRTEL: string = "BO_CNX_PRTEL";
  public static REL_BO_CENTFACT_BO_FACTURE: string = "REL_BO_CENTFACT_BO_FACTURE";
  public static REL_BO_BUREAU_BO_PLAN_ALIMENTAIRE: string = "REL_BO_BUREAU_BO_PLAN_ALIMENTAIRE";
  public static REL_DEVIS_LIGNEDEVIS: string = "REL_BO_DEVIS_BO_LIGNEDEVIS";
  public static REL_BO_BUREAU_BO_FICHE_APPROUVE: string = "REL_BO_BUR_FICHE_APP";
  public static REL_BO_BUREAU_BO_FICHE_APPROUVEOK: string = "REL_BO_BUR_FICHE_APPOK";
  public static REL_BO_BUREAU_BO_COMMANDE: string = "REL_BO_BUREAU_BO_COMMANDE";
  public static REL_BO_LIGNEDEVIS_BO_COMMANDE: string = "REL_BO_LIGNEDEVIS_BO_COMMANDE";
  public static REL_BO_FOURNISSEUR_BO_COMMANDE: string = "REL_BO_FOURNISSEUR_BO_COMMANDE";
  public static REL_BO_ADRESSE_LIVRAISON_BO_COMMANDE_F: string = "REL_BO_ADRESSE_LIVRAISON_BO_COMMANDE_F";
  public static REL_BO_FOURNISSEUR_BO_COMMANDE_FOURNISSEUR: string = "REL_BO_FOURNISSEUR_BO_COMMANDE_F";
  public static REL_BO_AFFAIRE_BO_COMMANDE_FOURNISSEUR: string = "REL_BO_AFFA_BO_COMMANDE_F";
  public static REL_BO_AFFA_BO_TICKET_APPEL: string = "REL_BO_AFFA_BO_TICKET_APPEL";
  public static REL_BO_AFFA_BO_EMAIL: string = "REL_BO_AFFA_BO_EMAIL";
  public static REL_BO_STAGE_BO_EMAIL: string = "REL_BO_STAGE_BO_EMAIL";
  public static REL_BO_FOURNISSEUR_BO_COURRIER: string = "REL_BO_FOURNISSEUR_BO_COURRIER";
  public static REL_BO_CONTACT_BO_RESERV_P: string = "REL_BO_CONTACT_BO_RESERV_P";
  public static REL_BO_CONTACT_BO_RESERV_A: string = "REL_BO_CONTACT_BO_RESERV_A";
  public static REL_BO_CONTACT_BO_RESERV_I: string = "REL_BO_CONTACT_BO_RESERV_I";
  public static REL_BO_CONTACT_BO_RESERV_R: string = "REL_BO_CONTACT_BO_RESERV_R";
  public static REL_BO_STAGE_BO_RESERV: string = "REL_BO_STAGE_BO_RESERV";
  public static REL_BO_RESERV_BO_ADRESSE: string = "REL_BO_RESERV_BO_ADRESSE";
  public static REL_BO_PRODUIT_BO_RESERV: string = "REL_BO_PRODUIT_BO_RESERV";
  public static REL_BO_COMMANDE_BO_BONLIVRAISON: string = "REL_BO_COMMANDE_BO_BONLIVRAISON";
  public static REL_BO_BUREAU_BO_MENU: string = "REL_BO_BUREAU_BO_MENU";
  public static REL_BO_BUREAU_BO_OBJECTIF: string = "REL_BO_BUREAU_BO_OBJECTIF";
  public static REL_BO_BUREAU_BO_LIGNECOMMANDE: string = "REL_BO_BUREAU_BO_LIGNEDEVIS";
  public static REL_BO_COLLABO_BO_POSTIT: string = "REL_BO_COLLABO_BO_POSTIT";
  public static REL_BO_CENT_BO_FICHE_TECH: string = "REL_BO_CENT_BO_FICHE_TECH";
  public static REL_BO_FICHE_TECH_SECONDAIRE: string = "REL_BO_FICHE_TECH_BO_PROD_FICHE_TECH_SECONDAIRE";
  public static REL_BO_FICHE_TECH_PRINCIPALE: string = "REL_BO_FICHE_TECH_BO_PROD_FICHE_TECH_PRINCIPAL";
  public static REL_BO_CSOC_BO_RV: string = "REL_BO_CSOC_BO_RV";
  public static REL_BO_CONTACT_BO_RV: string = "REL_BO_CONTACT_BO_RV";
  public static REL_BO_CSOC_BO_STAGE: string = "REL_BO_CSOC_BO_STAGE";
  public static REL_BO_BO_BO_CATALOGUE: string = "REL_BO_BO_BO_CATALOGUE";
  public static REL_BO_CATALOGUE_BO_CATEGORIE: string = "REL_BO_CATALOGUE_BO_CATEGORIE";
  public static REL_BO_PAR_BO_CATEGORIE: string = "REL_BO_PAR_BO_CATEGORIE";
  public static REL_BlockPortail: string = "REL_BO_CNX_BO_BLKPTAL";
  public static REL_Conteneur: string = "REL_BO_CNX_BO_CONT_CONT";
  public static REL_Brick: string = "REL_BO_CONT_BO_BKC";
  public static REL_Lanceur: string = "REL_BO_CNX_BO_SHORTCUT";
  public static REL_Property: string = "REL_BO_BO_BO_PROP";
  public static REL_PERSONNEL_EMAIL: string = "REL_BO_PERSONNEL_BO_TICKET_COURRIER";
  public static REL_PERSONNEL_APPEL: string = "REL_BO_PERSONNEL_BO_TICKET_APPEL";
  public static REL_BO_CENT_BO_EXPERT: string = "REL_BO_CENT_BO_EXPERT";
  public static REL_BO_CENT_BO_INSTITUTION: string = "REL_BO_CENT_BO_INSTITUTION";
  public static REL_BO_INSTITUTION_BO_SERVICE_ER: string = "REL_BO_INSTITUTION_BO_SERVICE_ER";
  public static REL_BO_SERVICE_ER_BO_PRATICIEN: string = "REL_BO_SERVICE_ER_BO_PRATICIEN";
  public static REL_BO_ACTIONCLI_BO_REACTION: string = "REL_BO_ACTIONCLI_BO_REACTION";
  public static REL_PERSONNEL_FAX: string = "REL_BO_PERSONNEL_BO_TICKET_COURRIER";
  public static REL_PERSONNEL_COURRIER: string = "REL_BO_PERSONNEL_BO_TICKET_COURRIER";
  public static REL_CENT_DOSSIER_DOC: string = "REL_BO_CENT_BO_DOSSIERDOC";
  public static REL_DOSSIER_DOC_DOSSIER_DOC: string = "REL_BO_DOSSIER_DOC_BO_DOSSIER_DOC";
  public static REL_BO_DP_BO_DP: string = "REL_BO_DP_BO_DP";
  public static REL_BO_CSOC_BO_AFFA: string = "REL_BO_CSOC_BO_AFFA";
  public static REL_BO_CSOC_BO_DP: string = "REL_BO_CSOC_BO_DP";
  public static REL_BO_CONTACT_BO_AFFA: string = "REL_BO_CONTACT_BO_AFFA";
  public static REL_BO_DOSSIER_DOC_BO_DOCUMENT: string = "REL_BO_DOSSIER_DOC_BO_DOCUMENT";
  public static REL_BO_SHORTCUT_ONGLET1: string = "REL_BO_SHORTCUT_ONGLET1";
  public static REL_BO_SHORTCUT_ONGLET2: string = "REL_BO_SHORTCUT_ONGLET2";
  public static REL_BO_CONTACT_BO_STAGE: string = "REL_BO_CONTACT_BO_STAGE";
  public static REL_BO_CONTACT_BO_HISTOCLI: string = "REL_BO_CONTACT_BO_HISTOCLI";
  public static REL_BO_CPPT_BO_HISTOCLI: string = "REL_BO_CPPT_BO_HISTOCLI";
  public static REL_BO_FOURNISSEUR_BO_HISTOCLI: string = "REL_BO_FOURNISSEUR_BO_HISTOCLI";
  public static REL_BO_CONTACT_BO_DEVIS: string = "REL_BO_CONTACT_BO_DEVIS";
  public static REL_BO_STAGE_BO_CVT: string = "REL_BO_STAGE_BO_CVT";
  public static REL_BO_STAGE_BO_DVS: string = "REL_BO_STAGE_BO_DEVIS";
  public static REL_BO_TASK_BO_LIGNEDEVIS: string = "REL_BO_TASK_BO_LIGNEDEVIS";
  public static REL_BO_STAGE_BO_CNT: string = "REL_BO_STAGE_BO_CNT";
  public static REL_BO_STAGE_BO_PRODUIT: string = "REL_BO_STAGE_BO_PRODUIT";
  public static REL_BO_CONTACT_BO_DOCUMENT: string = "REL_BO_CONTACT_BO_DOCUMENT";
  public static REL_BO_CONTACT_BO_COURRIER: string = "REL_BO_CONTACT_BO_COURRIER";
  public static REL_BO_CYCLE_BO_COURRIER: string = "REL_BO_CYCLE_BO_COURRIER";
  public static REL_BO_STAGE_BO_COURRIER: string = "REL_BO_STAGE_BO_COURRIER";
  public static REL_BO_STAGE_BO_DOCUMENT: string = "REL_BO_STAGE_BO_DOCUMENT";
  public static REL_BO_STAGE_BO_ADRESSE: string = "REL_BO_STAGE_BO_ADRESSE";
  public static REL_BO_CONTACT_BO_CVT: string = "REL_BO_CONTACT_BO_CVT";
  public static REL_BO_DIRIGEANT_BO_CVT: string = "REL_BO_DIRIGEANT_BO_CVT";
  public static REL_BO_CSOC_BO_CVT: string = "REL_BO_CSOC_BO_CVT";
  public static REL_FINANCEUR_BO_CVT: string = "REL_FINANCEUR_BO_CVT";
  public static REL_BO_BO_ONGLET1: string = "REL_BO_BO_ONGLET1";
  public static REL_BO_BO_ONGLET2: string = "REL_BO_BO_ONGLET2";
  public static REL_BO_PRESTATION_BO_FTMPS: string = "REL_BO_PRESTATION_BO_FTMPS";
  public static REL_Entite_EntiteFact: string = "REL_BO_CENT_BO_CENTFACT";
  public static REL_EntiteFact_GrpFact: string = "REL_BO_CENTFACT_BO_GRPFACT";
  public static REL_Annuaire: string = "REL_BO_CENT_BO_ANNUAIRE";
  public static REL_Annuaire_Contact: string = "REL_BO_ANNUAIRE_BO_CONTACT";
  public static REL_ENTITE_CONTACT: string = "REL_BO_CENT_BO_CONTACT";
  public static REL_PERSONNEL_ALERTE: string = "REL_BO_PERSONNEL_BO_RV_ALERTE";
  public static REL_BO_PROP_BO_VALAUTO: string = "REL_BO_PROP_BO_VALAUTO";
  public static REL_COM_CPPT: string = "REL_BO_COLLABO_BO_CPPT_CO";
  public static REL_COM_CSOC: string = "REL_BO_COLLABO_BO_CSOC_CO";
  public static REL_EC_CSOC: string = "REL_BO_COLLABO_BO_CSOC_EC";
  public static REL_RM_CSOC: string = "REL_BO_COLLABO_BO_CSOC_RM";
  public static REL_AC_CSOC: string = "REL_BO_COLLABO_BO_CSOC_AC";
  public static REL_AS_CSOC: string = "REL_BO_COLLABO_BO_CSOC_AS";
  public static REL_AJ_CSOC: string = "REL_BO_COLLABO_BO_CSOC_AJ";
  public static REL_OS_CSOC: string = "REL_BO_COLLABO_BO_CSOC_OS";
  public static REL_CC_CSOC: string = "REL_BO_COLLABO_BO_CSOC_CC";
  public static REL_BO_COLLABO_BO_FICHCORRESP: string = "REL_BO_COLLABO_BO_FICHCORRESP";
  public static REL_BO_COLLABO_BO_AFFA: string = "REL_BO_COLLABO_BO_AFFA";
  public static REL_BO_COLLABO_BO_AFFA_GRC: string = "REL_BO_COLLABO_BO_AFFA_GRC";
  public static REL_SI_CSOC: string = "REL_BO_COLLABO_BO_CSOC_SI";
  public static REL_SE_CSOC: string = "REL_BO_COLLABO_BO_CSOC_SE";
  public static REL_MAJ_CSOC: string = "REL_BO_COLLABO_BO_CSOC_MAJ";
  public static REL_Listing: string = "REL_BO_EMAILING_BO_LISTING";
  public static REL_PJ: string = "REL_BO_EMAILING_BO_DOCUMENT";
  public static REL_Dossier_Emailing: string = "REL_BO_CENT_BO_EMAILING";
  public static REL_TASK_COLLABORATEUR: string = "REL_BO_COLLABO_BO_TASK";
  public static REL_BO_COLLABO_BO_SC: string = "REL_BO_COLLABO_BO_SC";
  public static REL_BO_CNX_BO_OBLIGATION: string = "REL_BO_CNX_BO_OBLIGATION";
  public static REL_COLLABO_TMP_COL: string = "REL_BO_COLLABO_BO_TMP_COL";
  public static REL_CPPT_FAX: string = "REL_BO_CPPT_BO_FAX";
  public static REL_FOURNISSEUR_FAX: string = "REL_BO_FOURNISSEUR_BO_FAX";
  public static REL_MISSION_TEMPS: string = "REL_MISSION_TEMPS";
  public static REL_BO_MISSION_BO_NOTFRAI: string = "REL_BO_MISSION_BO_NOTFRAI";
  public static REL_ClientArchive: string = "REL_BO_CENT_BO_CSOC_CLOT";
  public static REL_Client_Favoris: string = "REL_BO_CNX_BO_CSOC";
  public static REL_Client_RIB: string = "REL_BO_CSOC_BO_RIB";
  public static REL_ContactFournisseur: string = "REL_BO_FOURNISSEUR_BO_CONTACT";
  public static REL_ContactProspect: string = "REL_BO_CPPT_BO_CONTACT";
  public static REL_ContactSociete: string = "REL_BO_CSOC_BO_CONTACT";
  public static REL_ContactInstitution: string = "REL_BO_INSTITUTION_BO_CONTACT";
  public static REL_ContactPartenaire: string = "REL_BO_PARTENAIRE_BO_CONTACT";
  public static REL_ContactEntite: string = "REL_BO_CENT_BO_CONTACT";
  public static REL_DirigeantProspect: string = "REL_BO_CPPT_BO_DIRIGEANT";
  public static REL_DirigeantSociete: string = "REL_BO_CSOC_BO_DIRIGEANT";
  public static REL_BO_CENT_BO_BUREAU: string = "REL_BO_CENT_BO_BUREAU";
  public static REL_BO_PAR_BO_ACTIONCLI: string = "REL_BO_PAR_BO_ACTIONCLI";
  public static REL_BO_PAR_BO_PARAMTASK: string = "REL_BO_PAR_BO_PARAMTASK";
  public static REL_BUREAUX_COLLABO: string = "REL_BO_BUREAU_BO_COLLABO";
  public static REL_Task_Temps: string = "REL_BO_TASK_BO_FTMPS";
  public static REL_CSOC_PRESTATION: string = "REL_BO_CSOC_BO_PRESTATION";
  public static REL_CSOC_FAX: string = "REL_BO_CSOC_BO_FAX";
  public static REL_CSOC_COURRIER: string = "REL_BO_CSOC_BO_COURRIER";
  public static REL_CSOC_INFOS_FISCALES: string = "REL_BO_CSOC_BO_INFOFIS";
  public static REL_CSOC_EMAIL: string = "REL_BO_CSOC_BO_EMAIL";
  public static REL_CSOC_DOCUMENT: string = "REL_BO_CSOC_BO_DOCUMENT";
  public static REL_CSOC_LDM: string = "REL_BO_CSOC_BO_LDM";
  public static REL_CSOC_TARIFICATION: string = "REL_BO_CSOC_BO_TARIFICATION";
  public static REL_CSOC_FACTURE_TEMP: string = "REL_BO_CSOC_BO_FACTURE_TEMP";
  public static REL_CSOC_FACTURE: string = "REL_BO_CSOC_BO_FACTURE";
  public static REL_BO_CSOC_BO_FACTURE_DONNEURORDRE: string = "REL_BO_CSOC_BO_FACTURE_DONNEURORDRE";
  public static REL_CSOC_RELANCE: string = "REL_BO_CSOC_BO_RELANCE";
  public static REL_BO_CENT_BO_DOSSIER_COMPTA: string = "REL_BO_CENT_BO_DOSSIER_COMPTA";
  public static REL_BO_CENT_BO_DOSSIER_ARCHI: string = "REL_BO_CENT_BO_DOSSIER_ARCHI";
  public static REL_CSOC_LA: string = "REL_BO_CSOC_BO_LA";
  public static REL_BO_CPPT_BO_LDM: string = "REL_BO_CPPT_BO_LDM";
  public static REL_CPPT_LA: string = "REL_BO_CPPT_BO_LA";
  public static REL_BO_MCPTA_BO_FTMPS: string = "REL_BO_MCPTA_BO_FTMPS";
  public static REL_BO_MCAC_BO_FTMPS: string = "REL_BO_MCAC_BO_FTMPS";
  public static REL_BO_MCPTA_BO_MILLESIME: string = "REL_BO_MCPTA_BO_MILLESIME";
  public static REL_BO_MCAC_BO_TMP_TYPCOL_JN: string = "REL_BO_MCAC_BO_TMP_TYPCOL_JN";
  public static REL_BO_MCAC_BO_TMP_TYPCOL_SI: string = "REL_BO_MCAC_BO_TMP_TYPCOL_SI";
  public static REL_BO_MCAC_BO_TMP_TYPCOL_SN: string = "REL_BO_MCAC_BO_TMP_TYPCOL_SN";
  public static REL_BO_MCAC_BO_TMP_TYPCOL_RM: string = "REL_BO_MCAC_BO_TMP_TYPCOL_RM";
  public static REL_BO_MGESP_BO_MILLESIME: string = "REL_BO_MGESP_BO_MILLESIME";
  public static REL_BO_MCAC_BO_MILLESIME: string = "REL_BO_MCAC_BO_MILLESIME";
  public static REL_BO_MJUR_BO_MILLESIME: string = "REL_BO_MJUR_BO_MILLESIME";
  public static REL_BO_OBJET_BO_RESERV: string = "REL_BO_OBJET_BO_RESERV";
  public static REL_MCAC_LA: string = "REL_BO_MCAC_BO_LA";
  public static REL_MCAC_TMP_COL: string = "REL_BO_MCAC_BO_TMP_COL";
  public static REL_BO_MGEST_BO_FTMPS: string = "REL_BO_MGEST_BO_FTMPS";
  public static REL_BO_MGEST_BO_MILLESIME: string = "REL_BO_MGEST_BO_MILLESIME";
  public static REL_BO_MGESP_BO_FTMPS: string = "REL_BO_MGESP_BO_FTMPS";
  public static REL_BO_MJUR_BO_FTMPS: string = "REL_BO_MJUR_BO_FTMPS";
  public static REL_FOURNISSEUR: string = "REL_BO_CENT_BO_FOURNISSEUR";
  public static REL_BO_MISSION_BO_LIGNEDEVIS: string = "REL_BO_MISSION_BO_LIGNEDEVIS";
  public static REL_BO_MISSION_BO_TASK: string = "REL_BO_MISSION_BO_TASK";
  public static REL_MGESP_PRESTATION: string = "REL_BO_MGESP_BO_PRESTATION";
  public static REL_BO_MISSION_BO_DEVIS: string = "REL_BO_MISSION_BO_DEVIS";
  public static REL_Treeview: string = "REL_BO_TRW_BO_TRW";
  public static REL_Colonne: string = "REL_BO_TBL_BO_COL";
  public static REL_TreeviewPere: string = "REL_BO_BLOCK_BO_TRW";
  public static REL_AgendaPartage: string = "REL_BO_CNX_BO_CNX";
  public static REL_Groupe: string = "REL_BO_GROUP_BO_CNX";
  public static REL_BO_GROUP_BO_OBJET: string = "REL_BO_GROUP_BO_OBJET";
  public static PAR_GroupeObj: string = "REL_BO_PAR_BO_GROUP_OBJ";
  public static REL_Param: string = "REL_BO_PROP_BO_VALAUTO";
  public static REL_BO_CENT_BO_STAGE: string = "REL_BO_CENT_BO_STAGE";
  public static REL_BO_CENT_BO_FORMATEUR: string = "REL_BO_CENT_BO_FORMATEUR";
  public static REL_RESPONSABLE_BO_STAGE: string = "REL_RESPONSABLE_BO_STAGE";
  public static REL_BO_FORMATEUR_BO_STAGE: string = "REL_BO_FORMATEUR_BO_STAGE";
  public static REL_BO_FORMATEUR_BO_CNT: string = "REL_BO_FORMATEUR_BO_CNT";
  public static REL_BO_CENT_BO_CNT: string = "REL_BO_CENT_BO_CNT";
  public static REL_BO_CYCLE_BO_STAGE: string = "REL_BO_CYCLE_BO_STAGE";
  public static REL_Rdv: string = "REL_BO_CNX_BO_RV";
  public static REL_Reservation: string = "REL_BO_CNX_BO_RESERV";
  public static REL_postit: string = "REL_BO_COLLABO_BO_POSTIT";
  public static REL_ActionCO: string = "REL_BO_COLLABO_BO_ACTIONCO";
  public static REL_ClientSociete: string = "REL_BO_CENT_BO_CSOC";
  public static REL_Prospect: string = "REL_BO_CENT_BO_CPPT";
  public static REL_Personnel: string = "REL_BO_CENT_BO_PERSONNEL_SAL";
  public static REL_Entite: string = "REL_BO_PAR_BO_CENT";
  public static REL_ComptableSociete: string = "REL_BO_CSOC_BO_INTERLO_COMPT";
  public static REL_CLI_MissionConseil: string = "REL_BO_CSOC_BO_MGEST";
  public static REL_CLI_MissionSocial: string = "REL_BO_CSOC_BO_MGESP";
  public static REL_CLI_MissionJuridique: string = "REL_BO_CSOC_BO_MJUR";
  public static REL_CLI_MissionCAC: string = "REL_BO_CSOC_BO_MCAC";
  public static REL_CLI_MissionCompta: string = "REL_BO_CSOC_BO_MCPTA";
  public static REL_BO_CSOC_BO_RIB: string = "REL_BO_CSOC_BO_RIB";
  public static REL_PROS_ProjMissionCAC: string = "REL_BO_CPPT_BO_MCAC";
  public static REL_CLI_ProjMissionCAC: string = "REL_PROJ_BO_CSOC_BO_MCAC";
  public static REL_Collaborateur: string = "REL_BO_BUREAU_BO_COLLABO";
  public static REL_Temps: string = "REL_BO_COLLABO_BO_FTMPS";
  public static REL_CONTACT_APPEL: string = "REL_BO_CONTACT_BO_TICKET_APPEL";
  public static REL_CONTACT_FAX: string = "REL_BO_CONTACT_BO_TICKET_FAX";
  public static REL_CONTACT_COURRIER: string = "REL_BO_CONTACT_BO_TICKET_COURRIER";
  public static REL_EMAIL_TICKET_MAIL: string = "REL_BO_EMAIL_BO_TICKET_MAIL";
  public static REL_FAX_TICKET_FAX: string = "REL_BO_FAX_BO_TICKET_FAX";
  public static REL_COURRIER_TICKET_COURRIER: string = "REL_BO_COURRIER_BO_TICKET_COURRIER";
  public static REL_PROSPECT_COURRIER: string = "REL_BO_CPPT_BO_COURRIER";
  public static REL_BO_EXPERT_BO_LIGNE: string = "REL_BO_EXPERT_BO_LIGNE";
  public static REL_BO_CENT_TELERADIOLOGUE: string = "REL_BO_CENT_TELERADIOLOGUE";
  public static REL_BO_LIGNE_BO_DOCUMENT: string = "REL_BO_LIGNE_BO_DOCUMENT";
  public static REL_BO_CSOC_BO_ACCOMPTE_DONNEURORDRE: string = "REL_BO_CSOC_BO_ACCOMPTE_DONNEURORDRE";
  public static REL_BO_CSOC_BO_ACCOMPTE: string = "REL_BO_CSOC_BO_ACCOMPTE";
  public static REL_BO_ACCOMPTE_BO_ECHEANCIER: string = "REL_BO_ACCOMPTE_BO_ECHEANCIER";
  public static REL_BO_ACCOMPTE_BO_LIGNEACCOMPTE: string = "REL_BO_ACCOMPTE_BO_LIGNEACCOMPTE";
  public static REL_BO_FACTURE_TEMP_BO_LIGNEACCOMPTE: string = "REL_BO_FACTURE_TEMP_BO_LIGNEACCOMPTE";
  public static REL_BO_FACTURE_BO_LIGNEACCOMPTE: string = "REL_BO_FACTURE_BO_LIGNEACCOMPTE";
  public static REL_BO_FACTURE_BO_RELANCE: string = "REL_BO_FACTURE_BO_RELANCE";
  public static PAR_BlockPortail: string = "REL_BO_PAR_BO_BLKPTAL";
  public static PAR_Table: string = "REL_BO_PAR_BO_TBL";
  public static PAR_Relation: string = "REL_BO_PAR_BO_REL";
  public static PAR_BO: string = "REL_BO_PAR_BO_BO";
  public static PAR_User: string = "REL_BO_PAR_BO_CNX";
  public static PAR_Lanceur: string = "REL_BO_PAR_BO_SHORTCUT";
  public static PAR_Conteneur: string = "REL_BO_PAR_BO_CONT";
  public static PAR_Groupe: string = "REL_BO_PAR_BO_GROUP";
  public static PAR_Block_TREEVIEW: string = "REL_BO_PAR_BO_BLOCK";
  public static PAR_Workflow: string = "REL_BO_PAR_BO_WORKFLOW";
  public static PAR_VALAUTO: string = "REL_BO_PAR_BO_VALAUTO";
  public static REL_BO_FACTURE_TEMP_BO_LIGNEFACTURE: string = "REL_BO_FACTURE_TEMP_BO_LIGNEFACTURE";
  public static REL_BO_FACTURE_TEMP_BO_LIGNEFACTURE_REGUL: string = "REL_BO_FACTURE_TEMP_BO_LIGNEFACTURE_REGUL";
  public static REL_BO_FACTURE_BO_LIGNEFACTURE_REGUL: string = "REL_BO_FACTURE_BO_LIGNEFACTURE_REGUL";
  public static REL_BO_FACTURE_BO_LIGNEFACTURE: string = "REL_BO_FACTURE_BO_LIGNEFACTURE";
  public static REL_BO_FACTURE_TEMP_BO_LIGNEAVOIR: string = "REL_BO_FACTURE_TEMP_BO_LIGNEAVOIR";
  public static REL_BO_CSOC_BO_AVOIR: string = "REL_BO_CSOC_BO_AVOIR";
  public static REL_BO_CSOC_BO_AVOIR_TEMP: string = "REL_BO_CSOC_BO_AVOIR_TEMP";
  public static REL_BO_AVOIR_BO_LIGNEFACTURE: string = "REL_BO_AVOIR_BO_LIGNEFACTURE";
  public static REL_BO_AVOIR_BO_LIGNEAVOIR: string = "REL_BO_AVOIR_BO_LIGNEAVOIR";
  public static REL_BO_FACTURE_BO_BROUILLARD: string = "REL_BO_FACTURE_BO_BROUILLARD";
  public static REL_BO_DEBOURS_BO_LIGNEFACTURE: string = "REL_BO_DEBOURS_BO_LIGNEFACTURE";
  public static REL_BO_DEBOURS_BO_LIGNEAVOIR: string = "REL_BO_DEBOURS_BO_LIGNEAVOIR";
  public static REL_BO_LIGNEAVOIR_BO_BROUILLARD: string = "REL_BO_LIGNEAVOIR_BO_BROUILLARD";
  public static REL_BO_FACTURE_BO_REGLEMENT: string = "REL_BO_FACTURE_BO_REGLEMENT";
  public static REL_BO_CENTFACT_BO_RIB: string = "REL_BO_CENTFACT_BO_RIB_COMPTA";
  public static REL_PROJ_BO_CSOC_BO_MCPTA: string = "REL_PROJ_BO_CSOC_BO_MCPTA";
  public static REL_BO_GROUP_BO_TASK: string = "REL_BO_GROUP_BO_TASK";
  public static REL_BO_GROUP_BO_SC: string = "REL_BO_GROUP_BO_SC";
  public static REL_BO_CSOC_BO_CONTACT_FACT: string = "REL_BO_CSOC_BO_CONTACT_FACT";
  public static REL_BO_CSOC_BO_ADRESSE: string = "REL_BO_CSOC_BO_ADRESSE";
  public static REL_BO_CSOC_BO_ACTIONCO: string = "REL_BO_CSOC_BO_ACTIONCO";
  public static REL_BO_CPPT_BO_ACTIONCO: string = "REL_BO_CPPT_BO_ACTIONCO";
  public static REL_BO_CONTACT_BO_ACTIONCO: string = "REL_BO_CONTACT_BO_ACTIONCO";
  public static REL_BO_FOURNISSEUR_BO_BDC: string = "REL_BO_FOURNISSEUR_BO_BDC";
  public static REL_BO_CENT_BO_MEDIA: string = "REL_BO_CENT_BO_MEDIA";
  public static REL_BO_COURRIER_BO_QUESTSATISFACTION: string = "REL_BO_COURRIER_BO_QUESTSATISFACTION";
  public static REL_BO_COURRIER_BO_QUESTAVANTAPRESCONN: string = "REL_BO_COURRIER_BO_QUESTAVANTAPRESCONN";
  public static REL_BO_COURRIER_BO_QUESTAVANTAPRESPRAT: string = "REL_BO_COURRIER_BO_QUESTAVANTAPRESPRAT";
  public static REL_BO_QUESTGROUPE_BO_QUESTQUESTION: string = "REL_BO_QUESTGROUPE_BO_QUESTQUESTION";
  public static REL_BO_QUESTQUESTION_BO_QUESTREPONSE: string = "REL_BO_QUESTQUESTION_BO_QUESTREPONSE";
  public static REL_BO_QUESTREPONSE_BO_CONTACT: string = "REL_BO_QUESTREPONSE_BO_CONTACT";
  public static REL_BO_QUESTREPONSE_BO_CLIENT: string = "REL_BO_QUESTREPONSE_BO_CLIENT";
  public static REL_BO_COURRIER_BO_SELEARNTC: string = "REL_BO_COURRIER_BO_SELEARNTC";
  public static REL_BO_COURRIER_BO_SELEARNCHA: string = "REL_BO_COURRIER_BO_SELEARNCHA";
  public static REL_BO_COURRIER_BO_SELEARNHC: string = "REL_BO_COURRIER_BO_SELEARNHC";
  public static REL_BO_COURRIER_BO_ELEARN: string = "REL_BO_COURRIER_BO_SELEARN";
  public static REL_BO_CONGE_BO_COURRIER: string = "REL_BO_CONGE_BO_COURRIER";
  public static COL_CodePostal: string = "COL_tPAInsee_CodpoINS";
  public static COL_Ville: string = "COL_tPAInsee_TitreINS";
  public static COL_DtcreDOC: string = "COL_tDODocument_DtcreDOC";
  public static COL_CodeIdentUnic: string = "COL_tPAIdentUnique_Code_IDE";
  public static COL_CodeIdentRaisonSocialeClient: string = "COL_tDOClient_RaisoCLI";
  public static COL_CodeIdentNomPersonne: string = "COL_tDOPersonne_NomfaPER";
  public static PROP_PREST_CodauPRE: string = "PROP_PREST_CodauPRE";
  public static PROP_DEBOURS_Type: string = "PROP_BO_DEBOURS_Type_DEB";
  public static PROP_CONTACT_CivilPER: string = "PROP_CONTACT_CivilPER";
  public static PROP_DOCUMENT_Type_DOC: string = "PROP_DOCUMENT_Type_DOC";
  public static PROP_TASK_Etat: string = "PROP_TASK_Etat_EVE";
  public static PROP_TASK_Priorite: string = "PROP_TASK_Prio_EVE";
  public static PROP_TYPERDV: string = "PROP_RV_Type_EVE";
  public static PRO_FICHCORRESP_Etat_DOC: string = "PRO_FICHCORRESP_Etat_DOC";
  public static PRO_FICHCORRESP_Type_DOC: string = "PRO_FICHCORRESP_Type_DOC";
  public static PROP_BO_FACTURE_Etat_DOC: string = "PROP_BO_FACTURE_Etat_DOC";
  public static PROP_ACTIVITE_TEMPS: string = "PROP_FTMPS_ActivFDT";
  public static PRO_EXPERT_RegioPER: string = "PRO_EXPERT_RegioPER";
  public static REL_BO_CSOC_BO_RADIOLOGUE: string = "REL_BO_CSOC_BO_RADIOLOGUE";
  public static REL_BO_CSOC_BO_LIGNE: string = "REL_BO_CSOC_BO_LIGNE";
  public static REL_RADIOLOGUE_DEMANDEUR: string = "REL_RADIOLOGUE_DEMANDEUR";
  public static REL_BO_CSOC_BO_HISTOCLI: string = "REL_BO_CSOC_BO_HISTOCLI";
  public static REL_BO_CENT_BO_MODDEFAUT: string = "REL_BO_CENT_BO_MODDEFAUT";
  public static REL_BO_SERVENT_BO_PERSONNEL_RESP: string = "REL_BO_SERVENT_BO_PERSONNEL_RESP";
  public static REL_BO_SERVENT_BO_PERSONNEL_COLLABO: string = "REL_BO_SERVENT_BO_PERSONNEL_COLLABO";
  public static REL_BO_BUREAU_BO_SERVENT: string = "REL_BO_BUREAU_BO_SERVENT";
  public static REL_BO_PERSONNEL_BO_SALAIRE: string = "REL_BO_PERSONNEL_BO_SALAIRE";
  public static REL_BO_BUREAU_BO_PERSONNEL_RESPONSABLERH: string = "REL_BO_BUREAU_BO_PERSONNEL_RESPONSABLERH";
  public static REL_BO_PERSONNEL_BO_CONGE: string = "REL_BO_PERSONNEL_BO_CONGE";
  public static REL_PRESTATION_MODEFACTURATION: string = "REL_BO_PRESTATION_BO_MODEFACT";
  public static REL_CONVENTION_MODEFACTURATION: string = "REL_BO_CVT_BO_MODEFACT";
  public static REL_BO_CVT_BO_PRESTATION: string = "REL_BO_CVT_BO_PRESTATION";
  public static REL_BO_PRESTATION_BO_LIGNEFACTURE: string = "REL_BO_PRESTATION_BO_LIGNEFACTURE";
  public static REL_BO_PRESTATION_BO_LIGNEAVOIR: string = "REL_BO_PRESTATION_BO_LIGNEAVOIR";
  public static REL_BO_PERSONNEL_BO_DOCNF: string = "REL_BO_PERSONNEL_BO_DOCNF";
  public static REL_BO_PERSONNEL_BO_DOCGI: string = "REL_BO_PERSONNEL_BO_DOCNF_GI";
  public static REL_BO_DOCNF_BO_NOTFRAI: string = "REL_BO_DOCNF_BO_NOTFRAI";
  public static REL_BO_CENT_BO_FOURNISSEUR: string = "REL_BO_CENT_BO_FOURNISSEUR";
  public static REL_BO_CONTACT_BO_EMAILING: string = "REL_BO_CONTACT_BO_EMAILING";
  public static REL_PROCESS_COURRIER: string = "REL_BO_PROCESS_BO_COURRIER";
  public static REL_PRODUIT_COURRIER: string = "REL_BO_PRODUIT_BO_COURRIER";
  public static REL_BO_DIRIGEANT_BO_LDM: string = "REL_BO_DIRIGEANT_BO_LDM";
  public static REL_BO_CSOC_BO_LIGNEFACTURE_DONNEURORDRE: string = "REL_BO_CSOC_BO_LIGNEFACTURE_DONNEURORDRE";
  public static REL_BO_CSOC_BO_LIGNEFACTURE: string = "REL_BO_CSOC_BO_LIGNEFACTURE";
  public static REL_BO_CVT_BO_LIGNEFACTURE: string = "REL_BO_CVT_BO_LIGNEFACTURE";
  public static REL_BO_AFFA_BO_LIGNEFACTURE: string = "REL_BO_AFFA_BO_LIGNEFACTURE";
  public static REL_BO_MCPTA_BO_LIGNEFACTURE: string = "REL_BO_MCPTA_BO_LIGNEFACTURE";
  public static REL_BO_DEVIS_BO_LIGNEFACTURE: string = "REL_BO_DEVIS_BO_LIGNEFACTURE";
  public static REL_BO_LIGNEDEVIS_BO_LIGNEFACTURE: string = "REL_BO_LIGNEDEVIS_BO_LIGNEFACTURE";
  public static REL_BO_FACTURE_BO_GROUPE_LIGNEFACTURE: string = "REL_BO_FACTURE_BO_GROUPE_LIGNEFACTURE";
  public static REL_BO_GROUPE_LIGNEFACTURE_BO_LIGNEFACTURE: string = "REL_BO_GROUPE_LIGNEFACTURE_BO_LIGNEFACTURE";
  public static REL_BO_FACTURE_BO_LIGNEFACTURE_FRAIS: string = "REL_BO_FACTURE_BO_LIGNEFACTURE_FRAIS";
  public static REL_BO_CENT_BO_MODELQUESTIONNAIRE: string = "REL_BO_CENT_BO_MODELQUESTIONNAIRE";
  public static REL_BO_MODELQUESTION_BO_MODELREPONSE: string = "REL_BO_MODELQUESTION_BO_MODELREPONSE";
  public static REL_BO_MODELREPONSE_BO_MEDIA: string = "REL_BO_MODELREPONSE_BO_MEDIA";
  public static REL_BO_MODELQUESTION_BO_MEDIA: string = "REL_BO_MODELQUESTION_BO_MEDIA";
  public static REL_BO_MODELQUESTIONNAIRE_BO_MODELQUESTION: string = "REL_BO_MODELQUESTIONNAIRE_BO_MODELQUESTION";
  public static PROP_BO_CONNAISSANCE_CoursCON: string = "PROP_BO_CONNAISSANCE_CoursCON";
  public static PROP_BO_CONNAISSANCE_ModulCON: string = "PROP_BO_CONNAISSANCE_ModulCON";
  public static PROP_BO_CONTACT_CyclePER: string = "PROP_BO_CONTACT_CyclePER";
  public static PROP_BO_CNX_CyclePER: string = "PROP_BO_CNX_CyclePER";
  public static PROP_BO_CNX_PRT_CyclePER: string = "PROP_BO_CNX_PRT_CyclePER";
  public static PROP_BO_CNX_PRTEL_CyclePER: string = "PROP_BO_CNX_PRTEL_CyclePER";
  public static PROP_BO_CONTACT_Role_PER: string = "PROP_BO_CONTACT_Role_PER";
  public static PROP_BO_CNX_PRTEL_Role_PER: string = "PROP_BO_CNX_PRTEL_Role_PER";
  public static PROP_BO_CNX_PRT_Role_PER: string = "PROP_BO_CNX_PRT_Role_PER";
  public static PROP_BO_STAGE_Ques1PRO: string = "PROP_BO_STAGE_Ques1PRO";
  public static PROP_BO_STAGE_Ques2PRO: string = "PROP_BO_STAGE_Ques2PRO";
  public static PROP_BO_STAGE_Ques3PRO: string = "PROP_BO_STAGE_Ques3PRO";
  public static PROP_BO_STAGE_Ques4PRO: string = "PROP_BO_STAGE_Ques4PRO";
  public static PROP_BO_STAGE_Ques5PRO: string = "PROP_BO_STAGE_Ques5PRO";
  public static PROP_BO_STAGE_Ques6PRO: string = "PROP_BO_STAGE_Ques6PRO";
  public static PROP_BO_STAGE_Ques7PRO: string = "PROP_BO_STAGE_Ques7PRO";
  public static PROP_BO_STAGE_Ques8PRO: string = "PROP_BO_STAGE_Ques8PRO";
  public static PROP_BO_STAGE_Ques9PRO: string = "PROP_BO_STAGE_Ques9PRO";
  public static REL_BO_PAR_BO_CATALOGUE: string = "REL_BO_PAR_BO_CATALOGUE";
  public static REL_BO_CATEGORIE_BO_PRODUIT: string = "REL_BO_CATEGORIE_BO_PRODUIT";
  public static REL_BO_PRODUIT_BO_PRODUIT: string = "REL_BO_PRODUIT_BO_PRODUIT";
  public static REL_BO_PRODUIT_BO_LIGNEDEVIS: string = "REL_BO_PRODUIT_BO_LIGNEDEVIS";
  public static REL_BO_LIGNEDEVIS_BO_OPTION: string = "REL_BO_LIGNEDEVIS_BO_OPTION";
  public static REL_BO_MAINT_BO_LIGNEDEVIS: string = "REL_BO_MAINT_BO_LIGNEDEVIS";
  public static REL_BO_AFFA_BO_LIGNEDEVIS: string = "REL_BO_AFFA_BO_LIGNEDEVIS";
  public static REL_BO_AFFA_BO_OPTION: string = "REL_BO_AFFA_BO_OPTION";
  public static REL_BO_AFFA_BO_TASK: string = "REL_BO_AFFA_BO_TASK";
  public static REL_BO_AFFA_BO_DOCUMENT: string = "REL_BO_AFFA_BO_DOCUMENT";
  public static REL_BO_AFFA_BO_COURRIER: string = "REL_BO_AFFA_BO_COURRIER";
  public static REL_BO_AFFA_BO_DEVIS: string = "REL_BO_AFFA_BO_DEVIS";
  public static REL_BO_AFFA_BO_MODFACT: string = "REL_BO_AFFA_BO_MODFACT";
  public static REL_BO_CSOC_BO_MAINT: string = "REL_BO_CSOC_BO_MAINT";
  public static REL_BO_CSOC_BO_DEVIS: string = "REL_BO_CSOC_BO_DEVIS";
  public static REL_BO_FINANCEUR_BO_DEVIS: string = "REL_BO_FINANCEUR_BO_DEVIS";
  public static REL_BO_CSOC_BO_DEVIS_RAPIDE: string = "REL_BO_CSOC_BO_DEVIS_RAPIDE";
  public static REL_BO_CPPT_BO_DEVIS_RAPIDE: string = "REL_BO_CPPT_BO_DEVIS_RAPIDE";
  public static REL_BO_CPPT_BO_DEVIS: string = "REL_BO_CPPT_BO_DEVIS";
  public static REL_BO_MAINT_BO_LDM: string = "REL_BO_MAINT_BO_LDM";
  public static REL_BO_LIGNEDEVIS_BO_PRESTATION: string = "REL_BO_LIGNEDEVIS_BO_PRESTATION";
  public static REL_BO_LIGNE_BO_GROUPE_V: string = "REL_BO_LIGNE_BO_GROUPE_V";
  public static REL_BO_TELERADIO_BO_GROUPE_V: string = "REL_BO_TELERADIO_BO_GROUPE_V";
  public static REL_BO_PAR_BO_CATALOGUEEL: string = "REL_BO_PAR_BO_CATALOGUEEL";
  public static REL_BO_PAR_BO_CYCLEEL: string = "REL_BO_PAR_BO_CYCLEEL";
  public static REL_BO_CATALOGUEEL_BO_CHAPITRE: string = "REL_BO_CATALOGUEEL_BO_CHAPITRE";
  public static REL_BO_CYCLEEL_BO_CHAPITRE: string = "REL_BO_CYCLEEL_BO_CHAPITRE";
  public static REL_BO_CHAPITRE_BO_CONNAISSANCE: string = "REL_BO_CHAPITRE_BO_CONNAISSANCE";
  public static REL_BO_CENT_BO_CONNAISSANCE: string = "REL_BO_CENT_BO_CONNAISSANCE";
  public static REL_BO_CONTACT_BO_CYCLEEL: string = "REL_BO_CONTACT_BO_CYCLEEL";
  public static BO_PRODUIT: string = "BO_PRODUIT";
  public static BO_CATEGORIE: string = "BO_CATEGORIE";
  public static BO_COMMANDE: string = "BO_COMMANDE";
  public static BO_COMMANDE_FOURNISSEUR: string = "BO_COMMANDE_F";
  public static BO_BESOIN_INTERNE: string = "BO_BI";
  public static BO_MGMP: string = "BO_MGMP";
  public static BO_MANVISA: string = "BO_MANVISA";
  public static BO_MCOFFEPRIS: string = "BO_MCOFFEPRIS";
  public static BO_PROTOCOLE: string = "BO_PROTOCOLE";
  public static BO_HISTOPTE: string = "BO_HISTOPTE";
  public static BO_COLIS: string = "BO_COLIS";
  public static BO_PROCESS: string = "BO_PROCESS";
  public static REL_BO_MGMP_BO_PRODUIT: string = "REL_BO_MGMP_BO_PRODUIT";
  public static REL_BO_MANVISA_BO_PRODUIT: string = "REL_BO_MANVISA_BO_PRODUIT";
  public static REL_BO_MCOFFEPRIS_BO_PRODUIT: string = "REL_BO_MCOFFEPRIS_BO_PRODUIT";
  public static REL_BO_MGMP_BO_DOCUMENT: string = "REL_BO_MGMP_BO_DOCUMENT";
  public static REL_BO_MANVISA_BO_DOCUMENT: string = "REL_BO_MANVISA_BO_DOCUMENT";
  public static REL_BO_MCOFFEPRIS_BO_DOCUMENT: string = "REL_BO_MCOFFEPRIS_BO_DOCUMENT";
  public static REL_BO_PRODUIT_BO_PROCESS: string = "REL_BO_PRODUIT_BO_PROCESS";
  public static REL_BO_PROCESS_BO_PROTOCOLE: string = "REL_BO_PROCESS_BO_PROTOCOLE";
  public static REL_BO_PROTOCOLE_BO_HISTOPTE: string = "REL_BO_PROTOCOLE_BO_HISTOPTE";
  public static REL_BO_CSOC_BO_MGMP: string = "REL_BO_CSOC_BO_MGMP";
  public static REL_BO_CSOC_BO_MANVISA: string = "REL_BO_CSOC_BO_MANVISA";
  public static REL_BO_CSOC_BO_MCOFFEPRIS: string = "REL_BO_CSOC_BO_MCOFFEPRIS";
  public static REL_BO_PAR_BO_COLLABO: string = "REL_BO_PAR_BO_COLLABO";
  public static REL_BO_PAR_BO_COLLABO_CPOLE: string = "REL_BO_PAR_BO_COLLABO_CPOLE";
  public static REL_BO_PAR_BO_COLLABO_CPROJET: string = "REL_BO_PAR_BO_COLLABO_CPROJET";
  public static REL_BO_CENT_BO_DISTRIBUTEUR: string = "REL_BO_CENT_BO_DISTRIBUTEUR";
  public static REL_BO_DISTRIBUTEUR_BO_MGMP: string = "REL_BO_DISTRIBUTEUR_BO_MGMP";
  public static REL_BO_DISTRIBUTEUR_BO_MANVISA: string = "REL_BO_DISTRIBUTEUR_BO_MANVISA";
  public static REL_BO_DISTRIBUTEUR_BO_MCOFFEPRIS: string = "REL_BO_DISTRIBUTEUR_BO_MCOFFEPRIS";
  public static REL_BO_FABRICANT_BO_PRODUIT: string = "REL_BO_FABRICANT_BO_PRODUIT";
  public static REL_BO_CENT_BO_FABRICANT: string = "REL_BO_CENT_BO_FABRICANT";
}

export enum eELearningFrom {
  NONE,
  NOPARAMS,
  FROM_EXTRANET,
  FROM_LOGINSITE
}

export class LoginSoulEL {
  public From: eELearningFrom;
  public CD: string;
  public CD2: string;
  public sk: string;
  public sk2: string;
  public DataOK: boolean;
  constructor(queryStringParams: any) {
    this.From = eELearningFrom.NOPARAMS;
    this.CD = '';
    this.CD2 = '';
    this.sk = '';
    this.sk2 = '';
    this.DataOK = true;

    if (queryStringParams) {
      this.From = eELearningFrom.NONE;

      if (queryStringParams.CD && queryStringParams.CD2) {
        this.From = eELearningFrom.FROM_EXTRANET;
        this.CD = queryStringParams.CD;
        this.CD2 = queryStringParams.CD2;
        this.DataOK = this.CD !== '' && this.CD2 !== '';
      }

      if (queryStringParams.sk && queryStringParams.sk2) {
        this.From = eELearningFrom.FROM_LOGINSITE;
        this.sk = queryStringParams.sk;
        this.sk2 = queryStringParams.sk2;
        this.DataOK = this.sk !== '' && this.sk2 !== '';
      }

      if (this.From === eELearningFrom.NONE)
        this.DataOK = false;
    }
  }
}

export enum eExtranetFrom {
  NONE,
  NOPARAMS,
  //FROM_MAIL,
  FROM_EXPERT,
  FROM_LOGINSITE
}

export class LoginSoulEX {
  public From: eExtranetFrom;
  public CD: string;
  public CD2: string;
  public sk: string;
  public sk2: string;
  public DataOK: boolean;
  constructor(queryStringParams: any) {
    this.From = eExtranetFrom.NOPARAMS;
    this.CD = '';
    this.CD2 = '';
    this.sk = '';
    this.sk2 = '';
    this.DataOK = true;

    if (queryStringParams) {
      this.From = eExtranetFrom.NONE;

      if (queryStringParams.CD && queryStringParams.CD2) {
        this.From = eExtranetFrom.FROM_EXPERT;
        this.CD = queryStringParams.CD;
        this.CD2 = queryStringParams.CD2;
        this.DataOK = this.CD !== '' && this.CD2 !== '';
      }

      if (queryStringParams.sk && queryStringParams.sk2) {
        this.From = eExtranetFrom.FROM_LOGINSITE;
        this.sk = queryStringParams.sk;
        this.sk2 = queryStringParams.sk2;
        this.DataOK = this.sk !== '' && this.sk2 !== '';
      }

      if (this.From === eExtranetFrom.NONE)
        this.DataOK = false;
    }
  }
}
export class EtatDoc {
  public static A_VALIDER: string = "1";
  public static IMPRIME: string = "4";
  public static ANNULE: string = "10";
  public static SIGNE: string = "7";
  public static PERDU: string = "13";
  public static A_IMPRIMER: string = "3";
}

export enum eQuestFrom {
  NONE,
  NOPARAMS,
  FROM_MAIL,
  FROM_EXTRANET,
}

export class LoginSoulQS {
  public From: eQuestFrom;
  public user: string;
  public password: string;
  public P3: string;
  public P4: string;
  public dbName: string;
  public apiUrl: string;
  public mode: string;
  public idStage: string;
  public typeQuest: string;
  public CD = '';
  public CD2 = '';
  public DataOK: boolean;
  constructor(queryStringParams: any) {
    this.From = eQuestFrom.NOPARAMS;
    this.user = '';
    this.password = '';
    this.P3 = '';
    this.P4 = '';
    this.dbName = ''
    this.apiUrl = ''
    this.mode = ''
    this.idStage = '';
    this.typeQuest = '';
    this.CD = '';
    this.CD2 = '';
    this.DataOK = true;

    if (queryStringParams) {
      this.From = eQuestFrom.NONE;

      if (queryStringParams.P1 && queryStringParams.P2) {
        this.From = eQuestFrom.FROM_MAIL;
        this.user = queryStringParams.P1;
        this.password = queryStringParams.P2;
        this.P3 = queryStringParams.P3 ? queryStringParams.P3 : '';
        this.P4 = queryStringParams.P4 ? queryStringParams.P4 : '';
        this.dbName = queryStringParams.P5 ? queryStringParams.P5 : '';
        this.apiUrl = queryStringParams.P6 ? queryStringParams.P6 : '';
        this.mode = queryStringParams.mode ? queryStringParams.mode : '';
        this.idStage = queryStringParams.idStage ? queryStringParams.idStage : '';
        this.typeQuest = queryStringParams.mode ? queryStringParams.typeQuest : '';
        this.DataOK = this.user !== '' && this.password !== '' && this.dbName !== '' && this.apiUrl !== '';
      }

      if (queryStringParams.CD && queryStringParams.CD2) {
        this.From = eQuestFrom.FROM_EXTRANET;
        this.CD = queryStringParams.CD;
        this.CD2 = queryStringParams.CD2;
        this.DataOK = this.CD !== '' && this.CD2 !== '';
      }

      if (this.From === eQuestFrom.NONE)
        this.DataOK = false;
    }
  }
}
